module.exports = __webpack_public_path__ + "img/28.8ce6ed40.png";